/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Sklik_UrlInputs */

const cs_form_sklik_url = /** @type {(inputs: Form_Sklik_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik vlastní URL`)
};

const en_form_sklik_url = /** @type {(inputs: Form_Sklik_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik custom URL`)
};

/**
* | output |
* | --- |
* | "Sklik custom URL" |
*
* @param {Form_Sklik_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_sklik_url = /** @type {((inputs?: Form_Sklik_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Sklik_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_sklik_url(inputs)
	return cs_form_sklik_url(inputs)
});